"use client";

import { useEffect, useState } from "react";
import { CircularProgress, Box } from "@mui/material";

export default function ClientOnly({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}>
        <CircularProgress size={40} />
      </Box>
    );
  }

  return <>{children}</>;
}
